"use client";
import React from "react";
import isEmpty from "lodash/isEmpty";
import {
  Heading,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import {TEXT_VARIANTS} from "@/theme/components/text";
import {
  useTextVariants,
  useSectionHeadingVariant,
} from "@/theme/components/useSectionHeading";
import BgImage from "public/shared/dotted-background-image.png";

type Props = {
  description?: string;
  list?: {label: string; text: string}[];
  title: string;
};

const PlainCard = (props: Props) => {
  const {description, list = [], title} = props;
  const HeadingVariant = useSectionHeadingVariant();
  const textVariant = useTextVariants();
  const mid = Math.ceil(list.length / 2);
  const list1 = list.slice(0, mid);
  const list2 = list.slice(mid);
  return (
    <VStack
      backgroundColor="primary.200"
      backgroundImage={BgImage.src}
      backgroundPosition={"center"}
      backgroundSize={"cover"}
      backgroundRepeat="no-repeat"
      borderRadius={"16px"}
      className="brand-shadow"
      px={6}
      py={12}
      spacing={6}
      _hover={{
        boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.3)",
        transform: "translateY(-5px) scale(1.02)",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Heading variant={HeadingVariant} textAlign={"center"} color="white" mb={6}>
        {title}
      </Heading>
      {description && (
        <Text
          lineHeight={"1.4"}
          maxW={"900px"}
          textAlign={"center"}
          variant={TEXT_VARIANTS.BODY1}
          color="white"
        >
          {description}
        </Text>
      )}
      {!isEmpty(list) && (
        <SimpleGrid
          columns={{base: 1, md: 2}}
          spacing={8}
          width={{base: "100%", lg: "80%"}}
        >
          {[list1, list2].map((list, index) => (
            <UnorderedList key={index} spacing={3} color="white">
              {list.map((item, index) => (
                <ListItem key={index}>
                  <Text as="span" fontWeight={600} variant={textVariant}>
                    {item.label} :{" "}
                  </Text>
                  <Text as="span" variant={textVariant}>
                    {item.text}
                  </Text>
                </ListItem>
              ))}
            </UnorderedList>
          ))}
        </SimpleGrid>
      )}
    </VStack>
  );
};

export default PlainCard;
